<template>
    <div class="invoicing-page-layout">
        <SudosuFrame />
        <Navbar />

        <div class="invoicing-main">
            <slot />
        </div>

        <FooterLogged />
    </div>
</template>

<script setup lang="ts">
    import {FooterLogged, Navbar, SudosuFrame} from '#components';
</script>
